module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[104]225.3146c2f.woff2";